import { render, staticRenderFns } from "./ReportWidgetDetailsModal.vue?vue&type=template&id=7380b8cd"
import script from "./ReportWidgetDetailsModal.vue?vue&type=script&lang=js"
export * from "./ReportWidgetDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ReportWidgetDetailsModal.vue?vue&type=style&index=0&id=7380b8cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports